export const LangText: any = {
    us: {
        protocol: `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Service</a>.`,
        learn_btn: 'Learn More',
        emailPlace: 'Provide your email',
        btn: 'Subscribe',
        day: 'DAYS',
        hour: 'HOURS',
        min: 'MINUTES',
        sec: 'SECONDS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Please agree to the Terms of Use and Privacy Policy.',
        email_error_tip1: 'Please enter the email address.',
        email_error_tip2: 'Please enter a valid email address.',
        success_tips: 'Sign up successfully! Check your inbox for coupons.',
    },
    ca: {
        protocol: `I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Service</a>.`,
        learn_btn: 'Learn More',
        emailPlace: 'Provide your email',
        btn: 'Subscribe',
        day: 'DAYS',
        hour: 'HOURS',
        min: 'MINUTES',
        sec: 'SECONDS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Please agree to the Terms of Use and Privacy Policy.',
        email_error_tip1: 'Please enter the email address.',
        email_error_tip2: 'Please enter a valid email address.',
        success_tips: 'Sign up successfully! Check your inbox for coupons.',
    },
    eu: {
        protocol:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        learn_btn: 'Learn More',
        emailPlace: 'Drop Your Email',
        btn: 'Subscribe',
        day: 'DAYS',
        hour: 'HOURS',
        min: 'MINUTES',
        sec: 'SECONDS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Please agree to the Terms of Use and Privacy Policy.',
        email_error_tip1: 'Please enter the email address.',
        email_error_tip2: 'Please enter a valid email address.',
        success_tips: 'Sign up successful.',
    },
    za: {
        protocol:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-za/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-za/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        learn_btn: 'Learn More',
        emailPlace: 'Drop Your Email',
        btn: 'Subscribe',
        day: 'DAYS',
        hour: 'HOURS',
        min: 'MINUTES',
        sec: 'SECONDS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Please agree to the Terms of Use and Privacy Policy.',
        email_error_tip1: 'Please enter the email address.',
        email_error_tip2: 'Please enter a valid email address.',
        success_tips: 'Sign up successful.',
    },
    au: {
        protocol:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-au/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        learn_btn: 'Learn More',
        emailPlace: 'Drop Your Email',
        btn: 'Subscribe',
        day: 'DAYS',
        hour: 'HOURS',
        min: 'MINUTES',
        sec: 'SECONDS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Please agree to the Terms of Use and Privacy Policy.',
        email_error_tip1: 'Please enter the email address.',
        email_error_tip2: 'Please enter a valid email address.',
        success_tips: 'Sign up successful.',
    },
    uk: {
        protocol:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-uk/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-uk/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
        learn_btn: 'Learn More',
        emailPlace: 'Drop Your Email',
        btn: 'Subscribe',
        day: 'DAYS',
        hour: 'HOURS',
        min: 'MINUTES',
        sec: 'SECONDS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Please agree to the Terms of Use and Privacy Policy.',
        email_error_tip1: 'Please enter the email address.',
        email_error_tip2: 'Please enter a valid email address.',
        success_tips: 'Sign up successful.',
    },
    de: {
        protocol:
            'Ich stimme den <a href="https://account.ecoflow.com/agreement/de-de/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen </a> und der<a href="https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer"> Datenschutzrichtlinie</a> zu.',
        learn_btn: 'Mehr erfahren',
        emailPlace: 'E-Mail Adresse eingeben',
        btn: 'Abonnieren',
        day: 'TAGE',
        hour: 'STUNDEN',
        min: 'MINUTEN',
        sec: 'SEKUNDEN',
        success_title: 'Vielen Dank für Ihre Anmeldung!',
        success_desc: 'Wir informieren Sie vorab über alle neuen Angebote der EcoCredits Aktionswoche.',
        protocol_error_tips: 'Bitte stimmen Sie den Nutzungsbedingungen und der Datenschutzrichtlinie zu.',
        email_error_tip1: 'Bitte geben Sie die E-Mail Adresse ein.',
        email_error_tip2: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
        success_tips: 'Registrierung erfolgreich.',
    },
    fr: {
        protocol:
            'J\'accepte les <a href="https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Conditions d\'utilisation</a> et  <a href="https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">la Politique de confidentialité</a>.',
        learn_btn: 'En savoir plus',
        emailPlace: 'Adresse e-mail',
        btn: "S'abonner",
        day: 'JOURS',
        hour: 'HEURES',
        min: 'MINUTEN',
        sec: 'SECONDES',
        success_title: 'Merci de votre inscription !',
        success_desc: "Nous vous informerons à l'avance de toute nouvelle information concernant la semaine d’offres spéciales EcoCredits.",
        protocol_error_tips: "Veuillez accepter les Conditions d'utilisation et la Politique de confidentialité.",
        email_error_tip1: 'Veuillez saisir votre adresse e-mail.',
        email_error_tip2: 'Veuillez saisir une adresse e-mail valide.',
        success_tips: 'Inscription réussie.',
    },
    es: {
        protocol:
            'Acepto los <a href="https://account.ecoflow.com/agreement/es-es/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Términos de uso</a>  y la  <a href="https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Política de privacidad</a>.',
        learn_btn: 'Más información',
        emailPlace: 'Ingresa tu correo electrónico',
        btn: 'Suscribirse',
        day: 'DÍAS',
        hour: 'HORAS',
        min: 'MINUTOS',
        sec: 'SEGUNDOS',
        success_title: '¡Gracias por suscribirte!',
        success_desc: 'Te notificaremos con anticipación sobre cualquier novedad relacionada con la Semana EcoCredits de Agradecimiento',
        protocol_error_tips: 'Acepta los Términos de uso y la Política de privacidad.',
        email_error_tip1: 'Escribe tu dirección de correo electrónico',
        email_error_tip2: 'Escribe una dirección de correo electrónico válida.',
        success_tips: 'Registro exitoso.',
    },
    it: {
        protocol:
            'Accetto i <a href="https://account.ecoflow.com/agreement/it-it/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Termini di utilizzo</a> e <a href="https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">l’Informativa sulla privacy</a>.',
        learn_btn: 'Scopri di più',
        emailPlace: 'Comunicaci il tuo indirizzo e-mail',
        btn: 'Iscriviti',
        day: 'GIORNI',
        hour: 'ORE',
        min: 'MINUTI',
        sec: 'SECONDI',
        success_title: 'Grazie per avere effettuato l’iscrizione!',
        success_desc: 'Ti informeremo in anticipo su tutte le informazioni più recenti riguardanti la Settimana di apprezzamento degli EcoCredits.',
        protocol_error_tips: 'Accetta i Termini di utilizzo e l’Informativa sulla privacy.',
        email_error_tip1: 'Inserisci l’indirizzo e-mail.',
        email_error_tip2: 'Inserisci un indirizzo e-mail valido.',
        success_tips: 'Iscrizione riuscita.',
    },
    jp: {
        protocol:
            'EcoFlow の<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank" rel="noopener noreferrer">利用規約</a>に同意します',
        learn_btn: '詳しくはこちら',
        emailPlace: 'メールアドレス',
        btn: '今すぐ登録',
        day: '日',
        hour: '時間',
        min: '分',
        sec: '秒',
        success_title: 'おめでとうございます',
        success_desc: '特典を受け取りました！\nチェックアウト時にこのディスカウントコードを入力することで、対象商品の価格が割引されます。',
        protocol_error_tips: '「EcoFlowのプライバシーポリシーと利用規約に同意する」にチェックを入れてください',
        email_error_tip1: 'メールアドレスを入力してください',
        email_error_tip2: '有効なメールアドレスを入力してください（例：name@domain.com）',
        success_tips: 'ご登録ありがとうございます！',
    },
    kr: {
        protocol:
            '<a href="https://account.ecoflow.com/agreement/ko-kr/TermsOfUse.html" target="_blank" rel="noopener noreferrer">개인정보 보호정책</a> 및 <a href="https://account.ecoflow.com/agreement/ko-kr/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">이용약관에</a> 동의합니다.',
        learn_btn: '더 알아보기',
        emailPlace: '이메일 주소',
        btn: '구독',
        day: '일',
        hour: '시',
        min: '분',
        sec: '초',
        success_title: '보너스 에코포인트 지급 완료',
        success_desc: '보너스 에코포인트가 지급되었습니다. 자동 복사된 코드를 결제 전 입력하세요.',
        protocol_error_tips: '이용약관 및 개인정보 취급방침에 동의하십시오.',
        email_error_tip1: '이메일 주소를 입력해 주세요.',
        email_error_tip2: '올바른 이메일 주소를 입력해 주세요.',
        success_tips: '성공적으로 가입됩니다',
    },
    br: {
        protocol: `Eu concordo com os Termos de Uso e com a <a href="https://account.ecoflow.com/agreement/pt-br/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Política</a> de <a href="https://account.ecoflow.com/agreement/pt-br/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacidade</a>.`,
        learn_btn: 'Saiba mais',
        emailPlace: 'Provide your email',
        btn: 'Assine',
        day: 'DIAS',
        hour: 'HORAS',
        min: 'MINUTOS',
        sec: 'SEGUNDOS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Concorde com os Termos de Uso e com a Política de Privacidade.',
        email_error_tip1: 'Insira o endereço de e-mail válido.',
        email_error_tip2: 'Insira um endereço de e-mail válido.',
        success_tips: 'Inscrição feita com sucesso.',
    },
    mx: {
        protocol: `Acepto los <a href="https://account.ecoflow.com/agreement/es-mx/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Términos de uso</a> y la <a href="https://account.ecoflow.com/agreement/es-mx/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Política de privacidad</a>.`,
        learn_btn: 'Más información',
        emailPlace: 'Provide your email',
        btn: 'Suscribirse',
        day: 'DÍAS',
        hour: 'HORAS',
        min: 'MINUTOS',
        sec: 'SEGUNDOS',
        success_title: 'Thanks for subscribing!',
        success_desc: 'We will notify you in advance of any latest information regarding EcoCredits Monthly Madness.',
        protocol_error_tips: 'Acepta los Términos de uso y la Política de privacidad.',
        email_error_tip1: 'Ingresa tu dirección de correo electrónico.',
        email_error_tip2: 'Ingresa una dirección de correo electrónico válida.',
        success_tips: 'Suscripción correcta.',
    },
};
